import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-white">
      <div className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <img
                src="/logo_airmex.webp"
                alt="AIRMEX"
                className="h-10 w-auto object-contain bg-white rounded-md px-1"
              />
            </div>
            <p className="text-secondary-200 text-sm leading-relaxed mb-4">
              Instalación profesional de aires acondicionados con garantía y frescura. Más de 15 años brindando confort a hogares y negocios.
            </p>
            <div className="flex gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-700 hover:bg-primary-500 transition-colors" aria-label="Facebook">
                <i className="ri-facebook-fill text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-700 hover:bg-primary-500 transition-colors" aria-label="Instagram">
                <i className="ri-instagram-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-700 hover:bg-primary-500 transition-colors" aria-label="WhatsApp">
                <i className="ri-whatsapp-line text-sm"></i>
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-heading font-semibold text-base mb-4">Servicios</h4>
            <ul className="flex flex-col gap-2.5">
              {[
                'Instalación de AC',
                'Mantenimiento',
                'Reparación',
                'Instalación Comercial',
                'Recarga de Gas',
              ].map((item) => (
                <li key={item}>
                  <a href="#servicios" className="text-secondary-200 text-sm hover:text-white transition-colors">
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-heading font-semibold text-base mb-4">Empresa</h4>
            <ul className="flex flex-col gap-2.5">
              {[
                'Sobre Nosotros',
                'Nuestro Equipo',
                'Testimonios',
                'Blog',
                'Trabaja con Nosotros',
              ].map((item) => (
                <li key={item}>
                  <a href="#" className="text-secondary-200 text-sm hover:text-white transition-colors">
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading font-semibold text-base mb-4">Contacto</h4>
            <ul className="flex flex-col gap-3">
              <li className="flex items-start gap-2.5">
                <span className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-map-pin-line text-accent-400 text-sm"></i>
                </span>
                <span className="text-secondary-200 text-sm">Av. Principal 123, Ciudad Central</span>
              </li>
              <li className="flex items-center gap-2.5">
                <span className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-accent-400 text-sm"></i>
                </span>
                <a href="tel:+521234567890" className="text-secondary-200 text-sm hover:text-white transition-colors">
                  +52 1 234 567 890
                </a>
              </li>
              <li className="flex items-center gap-2.5">
                <span className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-accent-400 text-sm"></i>
                </span>
                <a href="mailto:contacto@airmex.com" className="text-secondary-200 text-sm hover:text-white transition-colors">
                  contacto@airmex.com
                </a>
              </li>
              <li className="flex items-center gap-2.5">
                <span className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i className="ri-time-line text-accent-400 text-sm"></i>
                </span>
                <span className="text-secondary-200 text-sm">Lun - Dom: 24/7</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-secondary-700 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-secondary-300 text-xs">
            &copy; {new Date().getFullYear()} AIRMEX. Todos los derechos reservados.
          </p>
          <div className="flex gap-4">
            <a href="#" className="text-secondary-300 text-xs hover:text-white transition-colors">
              Política de Privacidad
            </a>
            <a href="#" className="text-secondary-300 text-xs hover:text-white transition-colors">
              Términos de Servicio
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}